export default __webpack_public_path__ + "static/media/Rover.3422826d.png";